import { render, staticRenderFns } from "./modified-box.vue?vue&type=template&id=8c6f4258&scoped=true"
import script from "./modified-box.vue?vue&type=script&lang=js"
export * from "./modified-box.vue?vue&type=script&lang=js"
import style0 from "./modified-box.vue?vue&type=style&index=0&id=8c6f4258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6f4258",
  null
  
)

export default component.exports